import { render } from "./S720_PraxisgruppeEinstellungen.vue?vue&type=template&id=b259f0de&ts=true"
import script from "./S720_PraxisgruppeEinstellungen.vue?vue&type=script&lang=ts"
export * from "./S720_PraxisgruppeEinstellungen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__